<!--
 * @Description: 历史参与项目列表
 * @Date: 2020-11-06 16:38:28
-->
<template>
  <table-render
    ref="tableRender"
    :config="config"
    :propDate="{
      query: {
        userId: userId
      }
    }"
  >
    <template #top-alert>
      <el-form
        style="padding-left: 12px;margin: 31px 0 25px;"
        :model="row"
        label-position="left"
        inline
      >
        <el-form-item
          style="width:300px;"
          v-for="(item, index) in formClums"
          :key="index"
          :label="item.label"
        >
          <span v-if="item.prop === 'finishRate'">
            {{
              Number.isFinite(row[item.prop]) ? row['finishRate'] + '%' : '-'
            }}
          </span>
          <span v-else-if="item.prop === 'userAmount'">
            {{ moneyFixed(row[item.prop]) }}
          </span>
          <span
            v-else-if="
              item.prop !== 'fullName' &&
                item.prop !== 'phone' &&
                item.prop !== 'finishRate'
            "
          >
            {{ Number.isFinite(row[item.prop]) ? row[item.prop] : '-' }}
          </span>
          <span v-else>
            {{ row[item.prop] || '-' }}
          </span>
        </el-form-item>
      </el-form>
    </template>
  </table-render>
</template>

<script>
import tableRender from '@/components/tableRender';
import config from './config';
import { moneyFixed } from '@/tools/money';

export default {
  name: 'HistoryProject',
  props: {
    // 接口数据
    userId: {
      type: Number,
      default: 0,
      required: true
    },
    row: {
      type: Object,
      default: () => {}
    },
    //1-历史参与项目【查看】 2-历史参与项目【设置】
    source: {
      type: Number,
      default: 1,
      required: true
    }
  },
  data() {
    return {
      moneyFixed,
      formClums: [
        {
          label: this.row.userType == 2 ? '经营者：' : '自然人姓名：',
          prop: 'fullName'
        },
        { label: '手机号：', prop: 'phone' },
        { label: '剩余预采购任务量：', prop: 'taskSumSurplus' },
        { label: '系统接收中任务量：', prop: 'passingTaskSumPlatform' },
        { label: '系统已接收任务量：', prop: 'passTaskSumPlatform' },
        { label: '待审核任务总量：', prop: 'passingTaskSum' },
        { label: '未完成任务总量：', prop: 'noFinishTaskSum' },
        { label: '可结算任务量：', prop: 'submitNum' },
        { label: '预计结算服务总价（含税）：', prop: 'userAmount' },
        { label: '预采购任务量完成进度：', prop: 'finishRate' }
      ],
      form: {},
      config: null
    };
  },
  components: { tableRender },
  watch: {},
  computed: {},
  methods: {},
  created() {
    config[0].childMenu[0].defaultQuery = {
      userId: this.userId,
      source: this.source
    };
    this.config = config;
  }
};
</script>

<style scoped lang="scss"></style>
